import { render, staticRenderFns } from "./UnreviewedTable.vue?vue&type=template&id=77425584"
import script from "./UnreviewedTable.vue?vue&type=script&lang=js"
export * from "./UnreviewedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports